import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = loading, false = not authed, object = user
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("ccs_token", data.access_token);
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }, []);

  const signupStart = useCallback(async (payload) => {
    try {
      const { data } = await api.post("/auth/signup-start", payload);
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }, []);

  const signupVerify = useCallback(async (email, code) => {
    try {
      const { data } = await api.post("/auth/signup-verify", { email, code });
      if (data?.access_token) localStorage.setItem("ccs_token", data.access_token);
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }, []);

  const signupResend = useCallback(async (email) => {
    try {
      const { data } = await api.post("/auth/signup-resend", { email });
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("ccs_token");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, signupStart, signupVerify, signupResend, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
